var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.845 0h8.308c.98 0 1.783.802 1.783 1.78v16.44c0 .98-.803 1.78-1.781 1.78H5.847c-.98.002-1.783-.8-1.783-1.78V1.783C4.064.802 4.867 0 5.845 0ZM10 16.294a1.154 1.154 0 1 1 0 2.308 1.154 1.154 0 0 1 0-2.308ZM8.161 1.442h3.678a.05.05 0 0 1 .048.049v.537a.05.05 0 0 1-.048.049H8.16a.049.049 0 0 1-.048-.049v-.537c0-.028.02-.049.048-.049ZM5.635 3.505h8.73c.16 0 .29.131.29.29V15.19c0 .158-.132.29-.29.29h-8.73a.291.291 0 0 1-.29-.29V3.793a.29.29 0 0 1 .29-.288Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobile);
export default __webpack_public_path__ + "static/media/icon-mobile.04c7af93c1507fe72ae7d835c3048cf2.svg";
export { ForwardRef as ReactComponent };